import React, { useEffect, useState } from "react";
import { message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ConsentServices from "../Services/ConsentServices";
import MedicalService from "../Services/MedicalService";
import moment from "moment";
import { notifyDoctor, notifyMedicalRecordShare } from "../config/firebase";
import content from "../utils/TermsContent";

function GiveConsent() {
  const navigate = useNavigate();
  const [params, setParams] = useState();
  const [showConsent, setShowConsent] = useState(true);
  const [consentdata, setConsentdata] = useState();
  const [loading, setLoading] = useState(true);
  const [shareLoading, setShareLoading] = useState(false);
  const [checkedItems, setCheckedItems] = useState({
    terms: false,
    privacy: false,
    doctors: false,
    hospitals: false,
    pharmacy: false,
    diagnostics: false,
  });
  const [appointmentData, setAppointmentData] = useState({});

  const getCodeFromURL = () => {
    const query = window.location.search;
    const codeMatch = query.match(/ref=([^&]*)/);
    return codeMatch ? codeMatch[1] : null;
  };

  useEffect(() => {
    let param = getCodeFromURL();
    setParams(param);

    if (param) {
      getConsent(param);
    }
  }, []);

  const getConsent = async (params) => {
    setLoading(true);
    try {
      let appointmentDetails = await ConsentServices.GetAppointmentId(params);
      setAppointmentData(appointmentDetails?.data[0]);

      const payload = {
        // account_Id: appointmentDetails?.data[0]?.account_Id,
        // clinic_Id: appointmentDetails?.data[0]?.clinic_Id,
        patientId: appointmentDetails?.data[0]?.patientId,
      };

      const response = await ConsentServices.getconsentFilterForLink(payload);

      setCheckedItems({
        terms: response.data[0]?.termsCond === "Y" ? true : false,
        privacy: response.data[0]?.privacyPolicy === "Y" ? true : false,
        doctors: response.data[0]?.shareMedWithDocs === "Y" ? true : false,
        hospitals: response.data[0]?.shareMedWithHosp === "Y" ? true : false,
        pharmacy:
          response.data[0]?.shareEpresWithPharmacy === "Y" ? true : false,
        diagnostics:
          response.data[0]?.shareEpresWithDiagnostics === "Y" ? true : false,
      });

      const allConsentsGiven = [
        response.data[0]?.termsCond,
        response.data[0]?.privacyPolicy,
        response.data[0]?.shareMedWithDocs,
        response.data[0]?.shareMedWithHosp,
        response.data[0]?.shareEpresWithPharmacy,
        response.data[0]?.shareEpresWithDiagnostics,
      ].every((value) => value === "Y");

      if (allConsentsGiven) {
        let payload = {
          patientId: appointmentDetails?.data[0]?.patientId,
          userId: appointmentDetails?.data[0]?.userId,
          accessDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        };
        fetchRecords(payload);
        setShowConsent(false);
        setLoading(false);
      } else {
        setConsentdata(response.data);
        setShowConsent(true);
        setLoading(false);
      }
    } catch (e) {
      console.error("Error fetching consent:", e);
    }
  };

  const handleChange = (event) => {
    const { name, checked } = event.target;
    setCheckedItems((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const formatDate = () => {
    const now = new Date();
    return now
      .toLocaleString("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  };

  const handleSubmit = async () => {
    try {
      const postData = {
        appointmentId: appointmentData?.appointmentId,
        account_Id: appointmentData?.account_Id,
        clinic_Id: appointmentData?.clinic_Id,
        createdBy: appointmentData?.patientId,
        createdDate: formatDate(),
        modifiedBy: appointmentData?.patientId,
        modifiedDate: formatDate(),
        patientId: appointmentData?.patientId,
        privacyPolicy: checkedItems.privacy ? "Y" : "N",
        shareEpresWithDiagnostics: checkedItems.diagnostics ? "Y" : "N",
        shareEpresWithPharmacy: checkedItems.pharmacy ? "Y" : "N",
        shareMedWithDocs: checkedItems.doctors ? "Y" : "N",
        shareMedWithHosp: checkedItems.hospitals ? "Y" : "N",
        status: 1,
        termsCond: checkedItems.terms ? "Y" : "N",
      };
      const response =
        await ConsentServices.consentPostFromInviteLink(postData);

      if (
        postData?.shareEpresWithDiagnostics == "Y" &&
        postData?.shareEpresWithPharmacy == "Y" &&
        postData?.shareMedWithDocs == "Y"
      ) {
        let payload = {
          patientId: appointmentData?.patientId,
          userId: appointmentData?.userId,
          accessDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        };
        fetchRecords(payload);
        setShowConsent(false);
        setLoading(false);

        message.success("Consent submitted successfully!");
      } else {
        message.success("Give Consent to share the Records");
        setLoading(false);
      }
    } catch (error) {
      message.error("Failed to submit consent. Please try again.");
    }
  };

  const activePatient = JSON.parse(sessionStorage.getItem("patientData"));
  const patientCode = activePatient?.patientId;
  const [medicalRecord, setMedicalRecord] = useState(null);

  const [checkboxState, setCheckboxState] = useState({
    medicalHistory: false,
    prescription: false,
    reports: false,
    vitals: false,
    agree: true,
  });

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const handleShareClick = async () => {
    setShareLoading(true);
    let payload = {
      medicalHistory: checkboxState.medicalHistory ? "Y" : "N",
      prescription: checkboxState.prescription ? "Y" : "N",
      reports: checkboxState.reports ? "Y" : "N",
      vitals: checkboxState.vitals ? "Y" : "N",
      appointmentId: appointmentData?.appointmentId,
      status: 1,
    };
    try {
      const response =
        await MedicalService.ShareMedicalrecordsFromLink(payload);
      message.success("Medical Records Shared");

      try {
        // Share succeeded. The notification is best-effort and must not fail the share.
        await notifyMedicalRecordShare({
          senderId: appointmentData?.patientId,
          receiverId: appointmentData?.userId,
          apptId: appointmentData?.appointmentId,
        });
      } catch (notifyError) {
        console.error("Error notifying doctor:", notifyError);
      }

      navigate("/");
    } catch (error) {
      console.error("Error sharing medical records:", error);
    } finally {
      setShareLoading(false);
    }
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes(),
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const fetchRecords = async (payload) => {
    // let payload = {
    //   patientId: appointmentData?.patientId,
    //   userId: appointmentData?.userId,
    //   accessDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
    // };
    try {
      const result = await MedicalService.getShareMedicalrecords(payload);
      setMedicalRecord(result.data);
      setCheckboxState({
        medicalHistory: result.data[0]?.medicalHistory === "Y",
        prescription: result.data[0]?.prescription === "Y",
        reports: result.data[0]?.reports === "Y",
        vitals: result.data[0]?.vitals === "Y",
        // agree: result.data[0]?.status === 1,
      });
    } catch (error) {
      console.error("Error fetching medical records:", error);
    }
  };

  return (
    <div>
      {loading ? (
        <div>Loading.....</div>
      ) : (
        <div>
          {showConsent ? (
            <div className="min-h-screen">
              <div className=" mt-5">
                <div className="p-6 space-y-7  scrollWidth">
                  {/* Terms & Conditions */}
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      name="terms"
                      checked={checkedItems.terms}
                      onChange={handleChange}
                      className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
                    />
                    <span>Terms & Conditions</span>
                  </label>
                  {checkedItems.terms && (
                    <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
                      {content.terms}
                    </div>
                  )}

                  {/* Privacy Policy */}
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      name="privacy"
                      checked={checkedItems.privacy}
                      onChange={handleChange}
                      className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
                    />
                    <span>Privacy Policy</span>
                  </label>
                  {checkedItems.privacy && (
                    <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
                      {content.privacyPolicy}
                    </div>
                  )}

                  {/* Share Medical Records with Doctors */}
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      name="doctors"
                      checked={checkedItems.doctors}
                      onChange={handleChange}
                      className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
                    />
                    <span>Share Medical Records with Doctors</span>
                  </label>
                  {checkedItems.doctors && (
                    <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
                      {content.shareMedRecWithDoc}
                    </div>
                  )}

                  {/* Share Medical Records with Hospitals */}
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      name="hospitals"
                      checked={checkedItems.hospitals}
                      onChange={handleChange}
                      className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
                    />
                    <span>Share Medical Records with Hospitals</span>
                  </label>
                  {checkedItems.hospitals && (
                    <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
                      {content.shareMedWithHos}
                    </div>
                  )}

                  {/* Share e-Prescription with Pharmacy */}
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      name="pharmacy"
                      checked={checkedItems.pharmacy}
                      onChange={handleChange}
                      className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
                    />
                    <span>Share e-Prescription with Pharmacy</span>
                  </label>
                  {checkedItems.pharmacy && (
                    <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
                      {content.ePresWithPhar}
                    </div>
                  )}

                  {/* Share e-Prescription with Diagnostics */}
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      name="diagnostics"
                      checked={checkedItems.diagnostics}
                      onChange={handleChange}
                      className="w-4 h-4 text-[#189FAA] border-gray-300 rounded"
                    />
                    <span>Share e-Prescription with Diagnostics</span>
                  </label>
                  {checkedItems.diagnostics && (
                    <div className="mt-2 p-3 bg-gray-100 rounded-md text-sm whitespace-pre-wrap">
                      {content.ePresWithDiag}
                    </div>
                  )}
                </div>
                <div className="flex space-x-4 justify-end mt-5">
                  <button
                    onClick={handleSubmit}
                    className="px-4 py-1 bg-[#189FAA] text-white rounded-lg hover:bg-[#338f97]"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50 p-4 sm:p-3 overflow-y-auto">
              <div
                className="relative w-full max-w-sm sm:w-full bg-white border border-gray-200 rounded-xl shadow-2xl p-5 sm:p-4 my-auto max-h-[90vh] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="p-1 sm:p-0">
                  <div className="mb-3 pb-2 border-b border-gray-100">
                    <h3 className="text-lg sm:text-base font-semibold text-gray-800">
                      Share Medical Records
                    </h3>
                  </div>

                  <div className="space-y-1 sm:space-y-1.5">
                    <label
                      htmlFor="medicalHistory"
                      className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 active:bg-gray-100 cursor-pointer transition-colors"
                    >
                      <input
                        type="checkbox"
                        id="medicalHistory"
                        name="medicalHistory"
                        className="w-4 h-4 sm:w-5 sm:h-5 text-[#189FAA] border-gray-300 rounded focus:ring-[#189FAA] accent-[#189FAA] cursor-pointer"
                        checked={checkboxState.medicalHistory}
                        onChange={handleCheckboxChange}
                      />
                      <span className="text-base sm:text-sm font-medium text-gray-800 select-none">
                        Medical History
                      </span>
                    </label>

                    <label
                      htmlFor="prescription"
                      className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 active:bg-gray-100 cursor-pointer transition-colors"
                    >
                      <input
                        type="checkbox"
                        id="prescription"
                        name="prescription"
                        className="w-4 h-4 sm:w-5 sm:h-5 text-[#189FAA] border-gray-300 rounded focus:ring-[#189FAA] accent-[#189FAA] cursor-pointer"
                        checked={checkboxState.prescription}
                        onChange={handleCheckboxChange}
                      />
                      <span className="text-base sm:text-sm font-medium text-gray-800 select-none">
                        Prescription
                      </span>
                    </label>

                    <label
                      htmlFor="vitals"
                      className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 active:bg-gray-100 cursor-pointer transition-colors"
                    >
                      <input
                        type="checkbox"
                        id="vitals"
                        name="vitals"
                        className="w-4 h-4 sm:w-5 sm:h-5 text-[#189FAA] border-gray-300 rounded focus:ring-[#189FAA] accent-[#189FAA] cursor-pointer"
                        checked={checkboxState.vitals}
                        onChange={handleCheckboxChange}
                      />
                      <span className="text-base sm:text-sm font-medium text-gray-800 select-none">
                        Vitals
                      </span>
                    </label>

                    <label
                      htmlFor="reports"
                      className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 active:bg-gray-100 cursor-pointer transition-colors"
                    >
                      <input
                        type="checkbox"
                        id="reports"
                        name="reports"
                        className="w-4 h-4 sm:w-5 sm:h-5 text-[#189FAA] border-gray-300 rounded focus:ring-[#189FAA] accent-[#189FAA] cursor-pointer"
                        checked={checkboxState.reports}
                        onChange={handleCheckboxChange}
                      />
                      <span className="text-base sm:text-sm font-medium text-gray-800 select-none">
                        Reports
                      </span>
                    </label>
                  </div>

                  <hr className="my-3 border-gray-200" />

                  <label
                    htmlFor="agree"
                    className="flex items-start gap-3 p-2 rounded-lg cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      id="agree"
                      name="agree"
                      className="w-4 h-4 sm:w-5 sm:h-5 mt-0.5 text-[#189FAA] border-gray-300 rounded focus:ring-[#189FAA] accent-[#189FAA] cursor-pointer shrink-0"
                      checked={checkboxState.agree ?? true}
                      onChange={handleCheckboxChange}
                    />
                    <span className="text-sm sm:text-xs text-gray-700 leading-snug select-none">
                      I agree to share my Medical Records with the doctor
                    </span>
                  </label>

                  <div className="flex justify-end sm:justify-stretch gap-3 mt-4">
                    <button
                      onClick={handleShareClick}
                      disabled={shareLoading}
                      className={
                        "w-auto sm:w-full border-brand-primaryColor border rounded-lg px-5 py-2.5 sm:py-2 text-white flex items-center justify-center gap-2 text-sm font-medium bg-primaryColor hover:bg-[#158a94] active:scale-[0.99] transition-all disabled:opacity-70 disabled:cursor-not-allowed min-w-[80px]"
                      }
                    >
                      {shareLoading && <LoadingOutlined spin />}
                      <span>{shareLoading ? "Sharing..." : "Share"}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default GiveConsent;
